import { FieldInstanceForResolver } from "db/definitions";
import { batchAddFieldInstances } from "../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import { recordSentry } from "utils/recordSentry";
import { toFieldInstanceInputs } from "./toFieldInstanceInput";

async function batchCreateFieldInstances(fieldInstances: FieldInstanceForResolver[]): Promise<boolean> {
	if (fieldInstances.length > 0) {
		// Only the attributes the input type accepts are sent: an in-memory extra such as `tableFields` makes AppSync reject
		// the whole batch (2026-09-30, Red Rocks: the LINK repair dropped every batch this way and the fields it pointed at
		// never existed). LINK alt instances also carry `fieldTemplateId: null` by design, and null index keys are omitted
		// rather than sent because DynamoDB rejects them.
		const payload = toFieldInstanceInputs(fieldInstances as unknown as Record<string, unknown>[]);
		try {
			const client = generateClient({ authMode: "userPool" });
			await client.graphql({
				query: batchAddFieldInstances,
				variables: { fieldInstances: payload },
				authMode: "userPool",
			});
			return true;
		} catch (error) {
			// A failed batch means every item in it was dropped; record enough to find them.
			recordSentry({
				error,
				msg: "batchAddFieldInstances failed; the whole batch was dropped",
				additionalData: {
					count: fieldInstances.length,
					formGroup: fieldInstances[0]?.formGroup,
					ids: fieldInstances.slice(0, 5).map((fieldInstance) => fieldInstance.id),
				},
			});
		}
		return false;
	}
	return true;
}

export default batchCreateFieldInstances;
